<template>
<div>

  <Modal v-model="dialog" title="Confirmation" draggable>
    <div slot="close"><Icon size="20" class="close-icon" type="md-close" @click="revertChange(cellJSON)"/></div>
    <div class="fs-16 mb-2">Are you sure want to update field {{cellJSON.title||''}} ?</div>
    <Row class="fs-16">
      <Col span="4">From</Col><Col span="20"><b>{{cellJSON.oldValue?cellJSON.oldValue:'-'}}</b></Col>
      <Col span="4">To</Col><Col span="20"><b>{{cellJSON.newValue}}</b></Col>
    </Row>

    <div slot="footer">
      <Button type="primary" style="font-weight: bolder" :loading="cellJSON.loading" @click="updateCell(cellJSON)">
        <span v-if="!cellJSON.loading">OK</span>
        <span v-else>Loading...</span>
      </Button>
      <Button style="background: #999999; color: white;font-weight: bolder" @click="revertChange(cellJSON)">CANCEL</Button>
    </div>
  </Modal>

</div>
</template>

<script>
export default {
    name: "ConfirmCellUpdate",
    props: ['dialog', 'cellJSON'],
    methods:{
      updateCell({row, prop, newValue}){
       this.$emit('updateCell', {row, prop, newValue})
      },
      revertChange({row, prop, oldValue, hotInstance}){
        hotInstance.setDataAtRowProp(row, prop, oldValue, 'revert');
        this.$emit('update:cellJSON', {});
        this.$emit('update:dialog', false);
      }
    }
}
</script>

<style scoped>
.fs-16{
  font-size: 16px;
}
.mb-2{
  margin-bottom: 2px;
}
</style>
